import React from "react";
import type {
  Procedure,
  ProcedureDetail,
  ProcValidation,
} from "../../../../application/domain/proc-management";
import {
  ProcedureAcceptAppAtStoreInput,
  ProcedureAtStoreInfoFeeInput,
  ProcedureAtStoreInfoNoticeInput,
} from "../../../molecules/proc-management/form";

type Props = {
  procedure: ProcedureDetail | Procedure;
  onChange: (path: (string | number)[], value: any) => void;
  disabled?: boolean;
  shouldDisplayError: boolean;
  validationErrors: ProcValidation;
};

export const AtStoreInfoSection: React.FC<Props> = ({
  procedure,
  onChange,
  disabled = false,
  shouldDisplayError = false,
  validationErrors,
}) => {
  const { acceptIssueAtStore, atStoreInfo } = procedure;

  return (
    <section className="mb-5">
      <h2 className="subtitle">コンビニ交付での取り扱いについての説明</h2>

      <ProcedureAcceptAppAtStoreInput
        value={acceptIssueAtStore}
        onChange={onChange}
        basePath={["acceptIssueAtStore"]}
        disabled={disabled}
      />

      {acceptIssueAtStore && (
        <>
          <ProcedureAtStoreInfoFeeInput
            value={atStoreInfo?.fee}
            onChange={onChange}
            basePath={["atStoreInfo", "fee"]}
            disabled={disabled}
            shouldDisplayError={shouldDisplayError}
            errorMsg={validationErrors.atStoreInfo?.fee ?? ""}
          />

          <ProcedureAtStoreInfoNoticeInput
            basePath={["atStoreInfo", "notice"]}
            onChange={onChange}
            value={atStoreInfo?.notice}
            disabled={disabled}
            shouldDisplayError={shouldDisplayError}
            errorMsg={validationErrors.atStoreInfo?.notice ?? ""}
          />
        </>
      )}
    </section>
  );
};

export default AtStoreInfoSection;
